import { Injectable } from '@angular/core';
import { CoordinatorsService } from 'app/modules/coordinators/services/coordinators.service';
import { DoctorService } from 'app/modules/doctor/services/doctor.service';
import _ from 'lodash';
import { forkJoin, Observable } from 'rxjs';
import { RestResponse } from '../entities/rest.response-generic.model';
import { AuthorComponentData } from '../types/author-component-data.type';
import { DropDownOption } from '../types/dropdown-option.type';
import API from './api.config.json';
import { ApiService } from './api.service';
import { UsuarioService } from './usuario.service';

export type AuthorType = 'C' | 'M' | 'G' | 'E' | 'U';
export type AuthorDisplayValueType =
    | 'Yo'
    | 'Médico asignado'
    | 'Administrativo asignado'
    | 'Coordinador asignado'
    | 'Otro usuario'
    | 'Otro médico'
    | 'Otro coordinador'
    | 'La empresa'
    | 'La mutua';

export type AuthorDropdownOption = {
    value: AuthorType;
    viewValue: AuthorDisplayValueType;
};

export type AllDropDownOptions = {
    users: DropDownOption<number>[];
    doctors: DropDownOption<number>[];
    coordinators: DropDownOption<number>[];
};

@Injectable({
    providedIn: 'root',
})
export class AuthorComponentService {
    constructor(
        private apiService: ApiService,
        private usuarioService: UsuarioService,
        private doctorService: DoctorService,
        private coordinatorsService: CoordinatorsService
    ) {}

    /**
     * Get data for auth component
     */
    public getData(
        leaveId: number,
        companyId: number
    ): Observable<RestResponse<AuthorComponentData>> {
        let url = (API.AuthorComponent.getData as string).replace(
            '{companyId}',
            companyId.toString()
        );
        if (leaveId) url += `&leaveId=${leaveId}`;

        return this.apiService.get(url);
    }

    /**
     * Get all dropdown options
     */
    public async getDropdownOptions(): Promise<AllDropDownOptions> {
        // join all observables
        const joinedForks = forkJoin([
            this.usuarioService.getActiveUsersAbreviacions(),
            this.doctorService.GetActiveDoctorsDropdown() as Observable<
                DropDownOption<number>[]
            >,
            this.coordinatorsService.GetActiveCoordinators(),
        ]);

        const response = await joinedForks.toPromise();

        const [usersRes, doctorsRes, coordinatorsRes] = response;

        if (usersRes.code !== 0) throw new Error(usersRes.message);
        else if (coordinatorsRes.code !== 0)
            throw new Error(coordinatorsRes.message);

        return {
            users: usersRes.result,
            doctors: doctorsRes,
            coordinators: coordinatorsRes.result,
        };
    }

    /**
     * Set auhtors types list
     */
    public getAuthorTypesList(
        loggedUserAuthorType: AuthorType,
        leaveHasDoctor: boolean,
        companyHasAdmin: boolean,
        companyHasCoordinator: boolean
    ): AuthorDropdownOption[] {
        let list: AuthorDropdownOption[] = [
            { value: loggedUserAuthorType, viewValue: 'Yo' },
            { value: `M`, viewValue: 'Médico asignado' },
            { value: `G`, viewValue: 'Administrativo asignado' },
            { value: `C`, viewValue: 'Coordinador asignado' },
            { value: `G`, viewValue: 'Otro usuario' },
            { value: `M`, viewValue: 'Otro médico' },
            { value: `C`, viewValue: 'Otro coordinador' },
            { value: `E`, viewValue: 'La empresa' },
            { value: `U`, viewValue: 'La mutua' },
        ];

        if (!leaveHasDoctor)
            _.remove(
                list,
                (item: AuthorDropdownOption) =>
                    item.viewValue === 'Médico asignado'
            );
        if (!companyHasAdmin)
            _.remove(
                list,
                (item: AuthorDropdownOption) =>
                    item.viewValue === 'Administrativo asignado'
            );
        if (!companyHasCoordinator)
            _.remove(
                list,
                (item: AuthorDropdownOption) =>
                    item.viewValue === 'Coordinador asignado'
            );

        return list;
    }
}
